import { FBAnalyticsProvider, HotjarProvider, MSClarityProvider } from '@group-link-one/gl-utils';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { env } from '../env';
import { useCookieConsent } from '../utils/cookiesSetup';

interface AnalyticsProvidersProps {
  children: ReactNode;
}

export const AnalyticsProviders = ({ children }: AnalyticsProvidersProps) => {
  const { hasPermission } = useCookieConsent();
  const hasAnalyticsPermission = hasPermission('analytics');
  const { pathname } = useLocation();

  return (
    <FBAnalyticsProvider
      firebaseConfig={hasAnalyticsPermission ? env.VITE_REACT_APP_FB_CONFIG_JSON : null}
      pathname={hasAnalyticsPermission ? pathname : undefined}
    >
      <MSClarityProvider
        MSClarityProjectID={hasAnalyticsPermission ? (env.VITE_MS_CLARITY_PROJECT_ID ?? '') : ''}
      >
        <HotjarProvider
          autoInit={hasAnalyticsPermission}
          config={{
            siteId: hasAnalyticsPermission ? (env.VITE_HOTJAR_SITE_ID ?? 0) : 0,
            hotjarVersion: hasAnalyticsPermission ? env.VITE_HOTJAR_VERSION : undefined,
          }}
        >
          {children}
        </HotjarProvider>
      </MSClarityProvider>
    </FBAnalyticsProvider>
  );
};
